import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { WaveProvider } from "./context/WaveContext";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Restaurants from "./pages/Restaurants";
import RestaurantDetail from "./pages/RestaurantDetail";
import Events from "./pages/Events";
import Attendance from "./pages/Attendance";
import Invoices from "./pages/Invoices";
import Cashout from "./pages/Cashout";
import Users from "./pages/Users";
import Waves from "./pages/Waves";
import Employees from "./pages/Employees";
import Presupuesto from "./pages/Presupuesto";
import Audit from "./pages/Audit";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/restaurants" element={<Restaurants />} />
        <Route path="/restaurants/:id" element={<RestaurantDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/cashout" element={<Cashout />} />
        <Route path="/presupuesto" element={<Presupuesto />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/waves" element={<ProtectedRoute adminOnly><Waves /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
        <Route path="/audit" element={<ProtectedRoute adminOnly><Audit /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <WaveProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </WaveProvider>
    </AuthProvider>
  );
}
